import {Fragment, ReactNode} from "react";
import {format, Params} from "./format";

// A message with markup: <name>text</name> tags, each given its element by tags (a link, bold), around words that
// stay in the message, so a translation can put them anywhere in the sentence. {placeholders} are filled first.
export function rich(template: string, tags: { [name: string]: (text: string) => ReactNode }, params?: Params): ReactNode {
    const text = format(template, params);
    const parts: ReactNode[] = [];
    const pattern = /<(\w+)>(.*?)<\/\1>/g;
    let last = 0;
    for (let match = pattern.exec(text); match; match = pattern.exec(text)) {
        parts.push(text.substring(last, match.index));
        const tag = tags[match[1]];
        parts.push(<Fragment key={match.index}>{tag ? tag(match[2]) : match[2]}</Fragment>);
        last = pattern.lastIndex;
    }
    parts.push(text.substring(last));
    return <>{parts}</>;
}
